import type { DepartmentProjectType } from "@/core/lib/project-types";

import { getFaro } from "./faro";

export type RouteAccessRequirement =
  | `${DepartmentProjectType}_membership`
  | "department_membership"
  | "template_editor_access"
  | "superuser"
  | "org_admin"
  | "help_center_manager"
  | "bug_reports_enabled";

export interface RouteGuardContext {
  routeId: string;
  location: { pathname: string };
  preload: boolean;
}

// faro event attributes must be strings
type AccessDeniedEvent = Record<"guard" | "path" | "requirement", string>;

export function buildAccessDeniedEvent(
  guard: RouteGuardContext,
  requirement: RouteAccessRequirement,
): AccessDeniedEvent | null {
  if (guard.preload) return null;

  return {
    guard: guard.routeId,
    path: guard.location.pathname,
    requirement,
  };
}

export function reportAccessDenied(
  guard: RouteGuardContext,
  requirement: RouteAccessRequirement,
): void {
  const event = buildAccessDeniedEvent(guard, requirement);
  if (!event) return;

  getFaro()?.api.pushEvent("route.access_denied", event);
}
